var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.679,
    height: 15,
    viewBox: "0 0 34.679 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 -7.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6541",
    "data-name": "Group 6541",
    transform: "translate(0 7.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    "data-name": "Path 4719",
    className: "cls-1",
    d: "M3.651,8.325a.073.073,0,0,0-.056.029,48.557,48.557,0,0,0-3.421,5.4l-.1.2-.028.063a.546.546,0,0,0,.053.544c.568.888,3.752,1.926,10.862,1.926,5.3,0,10.933-.856,10.933-2.442,0-1.531-5.562-2.446-10.933-2.446a28.577,28.577,0,0,0-4.06.331c.485-.748,2.5-3.465,2.525-3.493a.066.066,0,0,0,.016-.04.094.094,0,0,0-.008-.032.083.083,0,0,0-.063-.037H3.651m2.071,5.719c0-.331,1.994-.794,5.243-.794s5.239.463,5.239.794-1.991.792-5.239.792-5.243-.461-5.243-.792",
    transform: "translate(0 -7.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    className: "cls-1",
    d: "M5.788,22.339s26.433,1.075,27-8.163C33.241,6.683,14.469,7.4,14.451,7.4s-.145.012-.145.119c0,.089.067.12.135.12,5.206,0,13.676,2.067,13.4,6.547C27.618,17.831,21.009,22.1,5.8,22.1a.139.139,0,0,0-.151.119c0,.056.033.108.141.119",
    transform: "translate(1.885 -7.377)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluray);
export default __webpack_public_path__ + "static/media/bluray.98b3fdd10656f1347cb4d21af74f4798.svg";
export { ForwardRef as ReactComponent };